<div class='wrapperTooltipSearch'>
  <span>{{ filtersS.matTooltip_for_search }}</span>
<!--  <div class='wrapperTooltipSearch__btn' (click)='emit.emit()'>Got it</div>-->
</div>